import { environment } from "src/environments/environment";
import Cookies from 'js-cookie';

export function hasPackagePermission(feature) {

  const planId = Cookies.get("PLANID");

  const freeId = environment.azurepackageFreeId;

  const basicId = environment.azurepackageBasicId;

  const premiumId = environment.azurepackagePremiumId;

  const isNormalUser = !planId || planId === 'undefined';



  if (!isNormalUser) {

    switch (feature) {
      case 'Annotate':
        return [freeId, basicId, premiumId].includes(planId);

      case 'Protocol':
        return [basicId, premiumId].includes(planId);

      case 'Kit':
        return [basicId, premiumId].includes(planId);

      case 'KitModel':
        return [basicId, premiumId].includes(planId);

      case 'RemoteManager':
        return [basicId, premiumId].includes(planId);

      case 'OTAManger':
        return [basicId, premiumId].includes(planId);

      case 'Maintenance':
        return [basicId, premiumId].includes(planId);

      case 'DevicePulse':
        return [premiumId].includes(planId);
      
      case 'UserApplication':
        return [basicId].includes(planId)

      case 'isNotAzureUser':
        return false;

      default:
        return false;
    }
  }
  return true;
}
